module.exports = __webpack_public_path__ + "img/garageTablet.590f70a0.png";